"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterAndValidateV3GetScoreList = void 0;
const schemas_1 = require("./schemas");
/**
 * Use this function when pulling a list of scores from the database before returning to the public API to ensure type safety.
 * All scores are expected to pass the validation. If a score fails validation, it will be logged.
 * @param scores
 * @returns list of validated v3 scores
 */
const filterAndValidateV3GetScoreList = (scores, onParseError) => scores.reduce((acc, ts) => {
    const result = schemas_1.APIScoreSchemaV3.safeParse(ts);
    if (result.success) {
        acc.push(result.data);
    }
    else {
        onParseError?.(result.error);
    }
    return acc;
}, []);
exports.filterAndValidateV3GetScoreList = filterAndValidateV3GetScoreList;
